/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React, { StrictMode } from 'react';
import { Row, Col, Alert, Clearfix } from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl, FormattedDate } from 'react-intl';
import { includes as _includes } from 'lodash';
import moment from 'moment';
import 'moment-timezone';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';
import { getSalutationOptions, getGenderForSalutation } from 'helpers/clients';
import InheritedOption from 'components/layout/client/InheritedOption';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import List from 'components/List';

import FormInput from 'components/forms/FormInput';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormDynamicData from 'components/forms/FormDynamicData';
import FormSwitchery from 'components/forms/FormSwitchery';
import may, { mayOneOf } from 'js/security';
import { ROLE_ROOT_EMPLOYEE, ROLE_CUSTOMER, ROLE_DIRECT_CUSTOMER, ROLE_WL_ADMIN } from 'js/constants';
import SimplePrompt from "components/layout/SimplePrompt";

const tzOptions = moment.tz.names().map(timezone => {
  return { value: timezone, label: timezone };
});

class ClientProfile extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 0,
      editCompanyAllowed: false,
    };

    this.defaultFieldTree = ['profile'];
  }

  isProjectLanguageChecked = language => {
    return !!_includes(this.props.entity.getLang().getProjectLanguages(), language);
  };

  projectLanguageChange = e => {
    const { target } = e;
    const language = target.value;
    const { checked } = target;

    const { entity, changeEntity } = this.props;
    let newValue;
    if (checked) {
      newValue = entity
        .getLang()
        .getProjectLanguages()
        .slice();
      newValue.push(language);
    } else {
      newValue = entity
        .getLang()
        .getProjectLanguages()
        .filter(r => {
          return r !== language;
        });
    }

    changeEntity({ ...entity.updateValue('projectLanguages', newValue, ['lang']) });
  };

  updateIdent = (name, value) => {
    const { entity, changeEntity } = this.props;
    changeEntity({ ...entity.updateValue(name, value, ['ident']) });
  };

  updateRemind = (name, value) => {
    const { entity, changeEntity } = this.props;
    changeEntity({ ...entity.updateValue(name, value, []) });
  };

  updateDemo = (name, value) => {
    const { entity, changeEntity } = this.props;
    changeEntity({ ...entity.updateValue(name, value, []) });
  };

  updateNeedsContentAuthorization = (name, value) => {
    const { entity, changeEntity } = this.props;
    changeEntity({ ...entity.updateValue(name, value, []) });
  };

  updateMainLanguage = (name, value) => {
    const { entity, changeEntity } = this.props;
    changeEntity({ ...entity.updateValue(name, value, ['lang']) });
  };

  updateSalutation = (name, value) => {
    const gender = getGenderForSalutation(value);

    const { entity, changeEntity } = this.props;
    let newEntity = { ...entity.updateValue('salutation', value, ['profile']) };
    newEntity = { ...entity.updateValue('gender', gender, ['profile']) };
    changeEntity(newEntity);
  };

  updateMainEntity = (name, value) => {
    const { entity, changeEntity } = this.props;
    changeEntity({ ...entity.updateValue(name, value, []) });
  };

  updateFinancial = (name, value) => {
    const { entity, changeEntity } = this.props;
    const newEntity = { ...entity.updateValue('email', value, ['financial']) };
    changeEntity(newEntity);
  };

  updateProfile = (propertyName, value) => {
    const { entity, changeEntity } = this.props;
    const newEntity = { ...entity.updateValue(propertyName, value, ['profile']) };
    changeEntity(newEntity);
  };

  confirmRegistration = e => {
    e.stopPropagation();
    e.preventDefault();

    const { entity, confirmRegistration } = this.props;
    confirmRegistration(entity.getUsername());
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      confirmRegistrationFormStatus,
      doNotify,
    } = this.props;

    if (
      prevProps.confirmRegistrationFormStatus.pending &&
      !confirmRegistrationFormStatus.pending &&
      !confirmRegistrationFormStatus.hasError
    ) {
      const { entity, changeEntity } = this.props;
      const newEntity = { ...entity.updateValue('registrationConfirmed', true) };
      changeEntity(newEntity);

      doNotify(1, messages.email_confirmed);
    }
  };

  setActiveTab = index => {
    this.setState({ activeTab: index });
  };

  getClassName = index => {
    const { activeTab } = this.state;
    return activeTab === index ? 'active' : '';
  };

  editCompany = () => {
    const { user } = this.props;
    if (may(ROLE_ROOT_EMPLOYEE, user.roles)) {
      this.setState({editCompanyAllowed: true})
    } else {
      this.setState({editCompanyAllowed: false})
    }
  }

  render() {
    const {
      intl: { messages },
      entityLoaded,
      entity,
      disabled,
      inModal,
      languages,
      user,
      confirmRegistrationFormStatus,
      typeOfUser,
      type,
    } = this.props;

    const { activeTab, editCompanyAllowed } = this.state;
    const profile = entity?.getProfile?.();
    const financial = entity?.getFinancial();

    const onlyActiveIf = type !== "new" && may(ROLE_ROOT_EMPLOYEE, user.roles);

    return (
      <div className="clearfix">
        <List noRender listName="languages" url="/api/languages.json" list={languages} />

        {entityLoaded && profile && (
          <Row className="menu-clients">
            <Col xs={12} md={inModal ? 4 : 4}>
              <div className={`menu-button ${this.getClassName(0)}`} onClick={() => this.setActiveTab(0)}>
                <h4 className="form-group-title">{messages.formGroup.basic_information}</h4>
              </div>
              <div className={`menu-button ${this.getClassName(1)}`} onClick={() => this.setActiveTab(1)}>
                {typeOfUser === 'customer' ? (
                  <h4 className="form-group-title">{messages.formGroup.contact_person}</h4>
                ) : (
                  <h4 className="form-group-title">{messages.formGroup.person_information}</h4>
                )}
              </div>
              <div className={`menu-button ${this.getClassName(2)}`} onClick={() => this.setActiveTab(2)}>
                <h4 className="form-group-title">{messages.formGroup.address_information}</h4>
              </div>
              <div className={`menu-button ${this.getClassName(3)}`} onClick={() => this.setActiveTab(3)}>
                <h4 className="form-group-title">{messages.formGroup.contact_data}</h4>
              </div>
              <div className={`menu-button ${this.getClassName(4)}`} onClick={() => this.setActiveTab(4)}>
                <h4 className="form-group-title">{messages.billing_settings}</h4>
              </div>
              <div className={`menu-button ${this.getClassName(5)}`} onClick={() => this.setActiveTab(5)}>
                <h4 className="form-group-title">{messages.success_management.title}</h4>
              </div>
              <div className={`menu-button ${this.getClassName(6)}`} onClick={() => this.setActiveTab(6)}>
                <h4 className="form-group-title">
                  {messages.languages} {languages.pending && <i className="m-l-10 fa fa-circle-notch fa-spin" />}
                </h4>
              </div>
              <div className={`menu-button ${this.getClassName(7)}`} onClick={() => this.setActiveTab(7)}>
                <h4 className="form-group-title">{messages.other_settings}</h4>
              </div>
              <div className={`menu-button ${this.getClassName(8)}`} onClick={() => this.setActiveTab(8)}>
                <h4 className="form-group-title">{messages.formGroup.permissions}</h4>
              </div>
            </Col>
            <Col xs={12} md={inModal ? 8 : 8}>
              <div>
                {activeTab === 0 && (
                  <div className="active-content">
                    <h4>{messages.formGroup.basic_information}</h4>
                    <div className="form-group-attached">
                      <Row>
                        <Col xs={onlyActiveIf ? 10 : 12} sm={onlyActiveIf ? 10 : 12}>
                          <FormInput
                            label={messages.company}
                            name="company"
                            value={profile.getCompany()}
                            meta={profile.getCompanyMetaInformation()}
                            validation={profile.getCompanyValidationResult()}
                            onChange={this.updateProfile}
                            disabled={disabled || (type !== 'new' && !editCompanyAllowed)}
                          />
                          {typeOfUser === 'customer' && (
                            <FormInput
                              label={messages.company_name}
                              name="companyName"
                              value={profile.getCompanyName()}
                              meta={profile.getCompanyNameMetaInformation()}
                              validation={profile.getCompanyNameValidationResult()}
                              onChange={this.updateProfile}
                              disabled={disabled || type !== 'new'}
                            />
                          )}
                        </Col>
                        <Col xs={onlyActiveIf ? 2 : 12} sm={onlyActiveIf ? 2 : 12}>
                          {onlyActiveIf && (
                            <>
                              <SimplePrompt
                                showLabel={true}
                                buttonLabel="Edit"
                                iconClass="fas fa-edit"
                                className="edit_company"
                                bsSize="md"
                                onSuccess={() => {
                                  this.editCompany();
                                }}
                              />
                            </>
                          )}
                        </Col>
                      </Row>




                      <FormInput
                        label={messages.email}
                        name="email"
                        value={profile.getEmail()}
                        meta={profile.getEmailMetaInformation()}
                        validation={profile.getEmailValidationResult()}
                        onChange={this.updateProfile}
                        disabled={disabled}
                      />
                      {entity.getUsername() && !entity.getRegistrationConfirmed() ? (
                        <Alert bsStyle="warning" className="no-margin">
                          <Clearfix>
                            <p className="col-xs-12 col-md-7 no-padding no-margin">Email not confirmed yet</p>
                            <p className="col-xs-12 col-md-5 no-padding no-margin text-right bold">
                              {confirmRegistrationFormStatus.pending ? (
                                <i className="fa circle-o-notch fa-spin text-warning" />
                              ) : (
                                <a href="#confirmRegistration" className="text-warning" onClick={this.confirmRegistration}>
                                  Confirm now
                                </a>
                              )}
                            </p>
                          </Clearfix>
                        </Alert>
                      ) : null}
                      {may(ROLE_ROOT_EMPLOYEE, user.roles) &&
                        (entity.getRoles().includes(ROLE_CUSTOMER) ||
                          entity.getRoles().includes(ROLE_DIRECT_CUSTOMER)) && (
                          <div className="form-group form-group-default padding-10">
                            <FormSwitchery
                              label={messages.is_never_remind}
                              name="isNeverRemind"
                              checked={entity.getIsNeverRemind()}
                              value
                              onChange={this.updateRemind}
                              disabled={disabled}
                            />
                          </div>
                        )}
                      <FormDynamicData
                        metaIdentifier="Client:Client"
                        entity={entity}
                        changeEntity={this.props.changeEntity}
                      />
                      {may('ROLE_ADMIN', user.roles) && typeOfUser === 'user' && (
                        <div className="form-group form-group-default padding-10">
                          <FormSwitchery
                            name="isActive"
                            checked={entity.getIsActive()}
                            value
                            label={messages.is_active}
                            onChange={this.updateMainEntity}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div>
                {activeTab === 1 && (
                  <div className="active-content">
                    {typeOfUser === 'customer' ? (
                      <h4>{messages.formGroup.contact_person}</h4>
                    ) : (
                      <h4>{messages.formGroup.person_information}</h4>
                    )}
                    <div className="form-group-attached">
                      <FormAutocomplete
                        label={messages.salutation}
                        name="salutation"
                        value={profile.getSalutation()}
                        meta={profile.getSalutationMetaInformation()}
                        validation={profile.getSalutationValidationResult()}
                        onChange={this.updateSalutation}
                        options={getSalutationOptions(messages)}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.title}
                        name="title"
                        value={profile.getTitle()}
                        meta={profile.getTitleMetaInformation()}
                        validation={profile.getTitleValidationResult()}
                        onChange={this.updateProfile}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.first_name}
                        name="firstName"
                        value={profile.getFirstName()}
                        meta={profile.getFirstNameMetaInformation()}
                        validation={profile.getFirstNameValidationResult()}
                        onChange={this.updateProfile}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.last_name}
                        name="lastName"
                        value={profile.getLastName()}
                        meta={profile.getLastNameMetaInformation()}
                        validation={profile.getLastNameValidationResult()}
                        onChange={this.updateProfile}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                )}
              </div>
              {activeTab === 2 && (
                <div className="active-content">
                  <h4>{messages.formGroup.address_information}</h4>
                  <div className="form-group-attached">
                    <FormInput
                      label={messages.street}
                      name="street"
                      value={profile.getStreet()}
                      meta={profile.getStreetMetaInformation()}
                      validation={profile.getStreetValidationResult()}
                      onChange={this.updateProfile}
                      disabled={disabled}
                    />

                    <Row className="clearfix">
                      <Col sm={6}>
                        <FormInput
                          label={messages.house_number}
                          name="houseNumber"
                          value={profile.getHouseNumber()}
                          meta={profile.getHouseNumberMetaInformation()}
                          validation={profile.getHouseNumberValidationResult()}
                          onChange={this.updateProfile}
                          disabled={disabled}
                        />
                      </Col>
                      <Col sm={6}>
                        <FormInput
                          label={messages.apartment_number}
                          name="apartmentNumber"
                          value={profile.getApartmentNumber()}
                          meta={profile.getApartmentNumberMetaInformation()}
                          validation={profile.getApartmentNumberValidationResult()}
                          onChange={this.updateProfile}
                          disabled={disabled}
                        />
                      </Col>
                      <Col sm={12}>
                        <FormInput
                          label={messages.address_line2}
                          name="addressLine2"
                          value={profile.getAddressLine2()}
                          meta={profile.getAddressLine2MetaInformation()}
                          validation={profile.getAddressLine2ValidationResult()}
                          onChange={this.updateProfile}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>

                    <Row className="clearfix">
                      <Col sm={6}>
                        <FormInput
                          label={messages.zip_code}
                          name="zipCode"
                          value={profile.getZipCode()}
                          meta={profile.getZipCodeMetaInformation()}
                          validation={profile.getZipCodeValidationResult()}
                          onChange={this.updateProfile}
                          disabled={disabled}
                        />
                      </Col>
                      <Col sm={6}>
                        <FormInput
                          label={messages.city}
                          name="city"
                          value={profile.getCity()}
                          meta={profile.getCityMetaInformation()}
                          validation={profile.getCityValidationResult()}
                          onChange={this.updateProfile}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>

                    <FormAutocomplete
                      label={messages.country}
                      name="country"
                      value={profile.getCountry()}
                      meta={profile.getCountryMetaInformation()}
                      validation={profile.getCountryValidationResult()}
                      onChange={this.updateProfile}
                      autocompleteType="country"
                      complete
                      disabled={disabled}
                    />

                    <div className="form-group-attached">
                      <FormAutocomplete
                        label={messages.timezone}
                        name="timezone"
                        value={profile.getTimezone()}
                        meta={profile.getTimezoneMetaInformation()}
                        validation={profile.getTimezoneValidationResult()}
                        onChange={this.updateProfile}
                        options={tzOptions}
                        complete
                        disabled={disabled}
                      />
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 3 && (
                <div className="active-content">
                  <h4>{messages.formGroup.contact_data}</h4>
                  <div className="form-group-attached">
                    <FormInput
                      label={messages.website}
                      name="website"
                      value={profile.getWebsite()}
                      meta={profile.getWebsiteMetaInformation()}
                      validation={profile.getWebsiteValidationResult()}
                      onChange={this.updateProfile}
                      disabled={disabled}
                    />
                    <FormInput
                      label={messages.phone}
                      name="phone"
                      value={profile.getPhone()}
                      meta={profile.getPhoneMetaInformation()}
                      validation={profile.getPhoneValidationResult()}
                      onChange={this.updateProfile}
                      disabled={disabled}
                      infoText={messages.client_settings_info_text.info_text_phone}
                    />
                    <FormInput
                      label={messages.mobile_phone}
                      name="mobile"
                      value={profile.getMobile()}
                      meta={profile.getMobileMetaInformation()}
                      validation={profile.getMobileValidationResult()}
                      onChange={this.updateProfile}
                      disabled={disabled}
                      infoText={messages.client_settings_info_text.info_text_mobile}
                    />
                    <FormInput
                      label={messages.fax}
                      name="fax"
                      value={profile.getFax()}
                      meta={profile.getFaxMetaInformation()}
                      validation={profile.getFaxValidationResult()}
                      onChange={this.updateProfile}
                      disabled={disabled}
                    />
                  </div>
                </div>
              )}

              {activeTab === 4 && (
                <div className="active-content">
                  <h4>{messages.billing_settings}</h4>
                  <div className="form-group-attached">
                    <FormInput
                      label={messages.invoice_email}
                      name="email"
                      value={financial?.getEmail()}
                      meta={financial?.getEmailMetaInformation()}
                      onChange={this.updateFinancial}
                      disabled={disabled}
                    />
                  </div>
                </div>
              )}

              {activeTab === 5 && (
                <div className="active-content">
                  <h4>{messages.success_management.title}</h4>
                  <div className="form-group-attached">
                    <FormAutocomplete
                      label={messages.success_management.manager}
                      name="successManager"
                      autocompleteType="user"
                      onChange={this.updateMainEntity}
                      disabled={disabled}
                    />

                    <div className="form-group form-group-default padding-10">
                      <FormSwitchery
                        label={messages.success_management.switch_title}
                        name="isLastSeenWatched"
                        checked={entity.getIsLastSeenWatched()}
                        value
                        onChange={this.updateMainEntity}
                        disabled={disabled}
                      />
                    </div>

                    <FormInput
                      label={messages.success_management.interval}
                      name="lastSeenIntervalDays"
                      value={entity.getLastSeenIntervalDays()}
                      meta={entity.getLastSeenIntervalDaysMetaInformation()}
                      validation={entity.getLastSeenIntervalDaysValidationResult()}
                      onChange={this.updateMainEntity}
                      disabled={disabled}
                    />
                    <div className="form-group-default">
                      <p>
                        {messages.success_management.last_seen}{' '}
                        {entity.getLastSeenDate() ? (
                          <FormattedDate
                            value={new Date(moment.tz(entity.getLastSeenDate(), 'UTC').tz(user.profile.timezone))}
                          />
                        ) : (
                          <>&mdash;</>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 6 && (
                <div className="active-content">
                  <h4>
                    {messages.languages}
                    {languages.pending && <i className="m-l-10 fa fa-circle-notch fa-spin" />}
                  </h4>
                  <h4>{messages.primary_language}</h4>
                  <div className="form-group-attached">
                    <FormAutocomplete
                      label={messages.primary_language}
                      name="mainLanguage"
                      value={entity.getLang().getMainLanguage()}
                      meta={entity.getLang().getMainLanguageMetaInformation()}
                      validation={entity.getLang().getMainLanguageValidationResult()}
                      onChange={this.updateMainLanguage}
                      options={languages.data.list.map(language => {
                        return { value: language.id, label: language.name };
                      })}
                      complete
                      infoText={messages.client_settings_info_text.info_text_main_language}
                    />
                  </div>

                  <h4>{messages.secondary_languages}</h4>
                  <div>
                    {languages.data.list.map((language, i) => {
                      return (
                        <div className="checkbox check-success" key={language.id}>
                          <input
                            disabled={disabled}
                            id={'clientLanguage' + i}
                            name="lang[]"
                            type="checkbox"
                            value={language.id}
                            checked={this.isProjectLanguageChecked(language.id)}
                            onChange={this.projectLanguageChange}
                          />
                          <label htmlFor={'clientLanguage' + i}>{language.name}</label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {activeTab === 7 && (
                <div className="active-content">
                  <h4>{messages.other_settings}</h4>
                  <div className="form-group-attached">
                    {may('ROLE_ADMIN', user.roles) && (
                      <div className="form-group form-group-default padding-10">
                        <FormSwitchery
                          name="isRenewPasswordAtNextLogin"
                          checked={entity.getIsRenewPasswordAtNextLogin()}
                          value
                          label={messages.is_renew_password_at_next_login}
                          onChange={this.updateMainEntity}
                          infoText={messages.client_settings_info_text.info_text_password_renew}
                        />
                      </div>
                    )}
                    <div className="form-group form-group-default padding-10">
                      <FormSwitchery
                        name="newsletter"
                        checked={entity.getProfile().getNewsletter()}
                        value
                        label={messages.newsletter}
                        onChange={this.updateProfile}
                      />
                    </div>
                    <div className="form-group form-group-default padding-10">
                      <FormSwitchery
                        name="editorAutosave"
                        checked={entity.getProfile().getEditorAutosave()}
                        value
                        label={messages.editorAutosave}
                        onChange={this.updateProfile}
                        infoText={messages.client_settings_info_text.info_text_editor_auto_save}
                      />
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 8 && (
                <div className="active-content">
                  <h4>{messages.formGroup.permissions}</h4>
                  <div className="form-group-attached">
                    {mayOneOf([ROLE_ROOT_EMPLOYEE, ROLE_WL_ADMIN], user.roles) && (
                      <>
                        {may(ROLE_ROOT_EMPLOYEE, user.roles) && (
                          <div className="form-group form-group-default padding-10">
                            <FormSwitchery
                              label={messages.is_demo}
                              name="isDemoClient"
                              checked={entity.getIsDemoClient()}
                              value
                              onChange={this.updateDemo}
                              disabled={disabled}
                              infoText={messages.client_settings_info_text.info_text_demo}
                            />
                          </div>
                        )}
                        <div className="form-group form-group-default padding-10">
                          <FormSwitchery
                            label={messages.image_rights_query}
                            name="imageRightsQuery"
                            checked={entity.getImageRightsQuery()}
                            value
                            onChange={this.updateMainEntity}
                            disabled={disabled}
                            infoText={messages.client_settings_info_text.info_text_image_rights_query}
                          />
                        </div>
                        <StrictMode>
                          <InheritedOption
                            entity={entity}
                            entityPropertyName="pdfDownloadOption"
                            onChange={this.updateMainEntity}
                            apiEndpoint={`/api/clients/${entity.getUsername()}/inheritedpdfdownloadoption.json`}
                            messageKey="pdf_download_option"
                            disabled={disabled}
                            infoText={messages.client_settings_info_text.info_text_pdf_download_option}
                          />
                        </StrictMode>
                      </>
                    )}
                    {may('ROLE_ADMIN', user.roles) && (
                      <div className="form-group form-group-default padding-10">
                        <FormSwitchery
                          name="needsContentAuthorization"
                          checked={entity.getNeedsContentAuthorization()}
                          value
                          label={messages.need_content_authorization}
                          onChange={this.updateNeedsContentAuthorization}
                          disabled={disabled}
                          infoText={messages.client_settings_info_text.info_text_needs_content_authorization}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
ClientProfile.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    languages: state.list.languages,
    confirmRegistrationFormStatus: state.formStatus.confirmRegistration,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    confirmRegistration: username => {
      formStatusDispatchHelper(
        'confirmRegistration',
        '/api/clients/' + username + '/confirmRegistration.json',
        {},
        'put',
        dispatch
      );
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ClientProfile)
);
